import { transformDateValue } from 'core/js/FormUtils';
export const getPhproductshapeView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let phproductshapeList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Form Name","fieldValue":transformDataValue(data.formname,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          phproductshapeList.push(card);
  })
  return phproductshapeList;
}